import React, { useState, useEffect } from "react";
import { Row, Col, ListGroup, Button, Tabs, Tab } from "react-bootstrap";
import event1 from "../../assets/images/event1.svg";
import event2 from "../../assets/images/event2.svg";
import event3 from "../../assets/images/event3.svg";
import event4 from "../../assets/images/event4.jpeg";
import club1 from "../../assets/images/club1.svg";
import club2 from "../../assets/images/events1.svg";
import { FaCalendarCheck } from "react-icons/fa6";
import { FaStar } from "react-icons/fa6";
import { BsFillPeopleFill } from "react-icons/bs";
import { useAuth } from "../../context/AuthContext";
import { GrCheckmark } from "react-icons/gr";
import { IoHeartCircle } from "react-icons/io5";
import { IoChatbox } from "react-icons/io5";
import { FaShare } from "react-icons/fa";
import { IoPaperPlane } from "react-icons/io5";

const eventsData = [
    {
        id: 1,
        type: "event",
        title: "NYE Disco Party 2025 at Park Club",
        club: "The Park Club",
        date: "2025-04-06T17:00:00",
        price: "$20.50",
        status: "Booked",
        img: event1,
        clubImg: club1,
        description: "The Westin Kolkata Rajarhat hosted 'Westination 2025,' featuring multiple celebrations including an open-air poolside party with DJ Girish.",
        going: 44,
        interested: 6,
        likes: "851",
        comments: "425",
        shares: "68",
        isInterested: false, // Default state
        isBooked: false, // Default state
    },
    {
        id: 2,
        type: "event",
        title: "Frosty's Fun Fest",
        club: "Santa Club",
        date: "2025-05-25T17:00:00",
        price: "Free",
        status: "Interested",
        img: event2,
        clubImg: club2,
        description: "A fun festival featuring holiday-themed activities, music, and food stalls for families and friends to enjoy together.",
        going: 30,
        interested: 12,
        likes: "751",
        comments: "325",
        shares: "60",
        isInterested: true,
        isBooked: false,
    },
    {
        id: 3,
        type: "event",
        title: "Valentines Day Party",
        club: "Santa Club",
        date: "2025-02-14T19:00:00",
        price: "$10.00",
        status: "Attended",
        img: event3,
        clubImg: club1,
        description: "Celebrate love and friendship at our Valentines Day Party with live music, candlelit dinners, and themed decorations.",
        going: 25,
        interested: 5,
        likes: "651",
        comments: "225",
        shares: "50",
        isInterested: false,
        isBooked: true,
    },
    {
        id: 4,
        type: "event",
        title: "Frosty's Fun Fest eve",
        club: "Santa Club",
        date: "2025-05-25T17:00:00",
        price: "Free",
        status: "Interested",
        img: event1,
        clubImg: club2,
        description: "A fun festival featuring holiday-themed activities, music, and food stalls for families and friends to enjoy together.",
        going: 30,
        interested: 12,
        likes: "851",
        comments: "425",
        shares: "68",
        isInterested: false,
        isBooked: true,
    },
    {
        id: 5,
        type: "event",
        title: "Chocolate day Party",
        club: "Santa Club",
        date: "2025-01-07T19:00:00",
        price: "$10.00",
        status: "Attended",
        img: event4,
        clubImg: club1,
        description: "Celebrate love and friendship at our Valentines Day Party with live music, candlelit dinners, and themed decorations.",
        going: 25,
        interested: 5,
        likes: "751",
        comments: "225",
        shares: "68",
        isInterested: true,
        isBooked: false,
    },
];

// Get the current date (set time to midnight for accurate filtering)
const getCurrentDate = () => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};


// Split into Scheduled and Past Events
const scheduledEvents = eventsData.filter(event => new Date(event.date) >= getCurrentDate());
const pastEvents = eventsData.filter(event => new Date(event.date) < getCurrentDate());

// Sort events by date
const sortedScheduledEvents = [...scheduledEvents].sort((a, b) => new Date(a.date) - new Date(b.date));
const sortedPastEvents = [...pastEvents].sort((a, b) => new Date(b.date) - new Date(a.date));

const Events = () => {
    const [activeTab, setActiveTab] = useState("scheduled");
    const [selectedEvent, setSelectedEvent] = useState(sortedScheduledEvents.length > 0 ? sortedScheduledEvents[0] : sortedPastEvents.length > 0 ? sortedPastEvents[0] : null);

    const [isBooked, setIsBooked] = useState(false);


    const handleBooking = () => {
        setIsBooked(true); // Change text to "Booked" on click
    };

    const [isInterested, setIsInterested] = useState(false); // Toggle state
    const { isAuthenticated } = useAuth();

    const handleInterestedToggle = () => {
        setIsInterested(!isInterested); // Toggle state
    };

    const [loved, setLoved] = useState(false);
    const [commentsOpen, setCommentsOpen] = useState(false); // Track visibility
    const [searchText, setSearchText] = useState("");

    // Update selected event when tab changes
    useEffect(() => {
        if (activeTab === "scheduled" && sortedScheduledEvents.length > 0) {
            setSelectedEvent(sortedScheduledEvents[0]);
        } else if (activeTab === "past" && sortedPastEvents.length > 0) {
            setSelectedEvent(sortedPastEvents[0]);
        } else {
            setSelectedEvent(null);
        }
    }, [activeTab]); // Runs whenever activeTab changes

    return (
        <div className="events-page">
            <h2 className="mb-20">Events</h2>
            <Row>
                {/* Sidebar with Tabs */}
                <Col md={5} lg={4} className="sidebar-events">
                    <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k)}
                        className="nav-pills-events" // ✅ Added nav-pills class
                        variant="pills" // ✅ This makes the tabs look like Pills
                    >
                        <Tab eventKey="scheduled" title="Scheduled Events">
                            {sortedScheduledEvents.length > 0 ? (
                                <ListGroup>
                                    {sortedScheduledEvents.map((event) => (
                                        <ListGroup.Item
                                            key={event.id}
                                            className={`event-item ${selectedEvent?.id === event.id ? "active" : ""}`}
                                            onClick={() => setSelectedEvent(event)}
                                        >
                                            <h5>{event.title}</h5>
                                            <p className="event-club"><img src={event.clubImg} alt={event.club} className="club-img" />{event.club}</p>

                                            <div className="event-img-wraper">
                                                <img src={event.img} alt={event.title} className="event-img" />

                                                {/* Show Tags for Booked & Interested */}
                                                {isAuthenticated && (
                                                    <div className="event-tags">
                                                        {event.isBooked && <span className="tag booked">Booked</span>}
                                                        {event.isInterested && <span className="tag interested">Interested</span>}
                                                    </div>
                                                )}
                                            </div>

                                            <p className="event-date">
                                                <FaCalendarCheck />
                                                {selectedEvent?.date
                                                    ? `${new Date(selectedEvent.date).toLocaleDateString("en-US", {
                                                        month: "short",
                                                        day: "2-digit",
                                                        year: "numeric",
                                                    })} | ${new Date(selectedEvent.date).toLocaleTimeString("en-US", {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true,
                                                    })}`
                                                    : "Date not available"}
                                            </p>
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            ) : (
                                <p className="text-center text-muted mt-3">No scheduled events</p>
                            )}
                        </Tab>

                        <Tab eventKey="past" title="Past Events">
                            {sortedPastEvents.length > 0 ? (
                                <ListGroup>
                                    {sortedPastEvents.map((event) => (
                                        <ListGroup.Item
                                            key={event.id}
                                            className={`event-item ${selectedEvent?.id === event.id ? "active" : ""}`}
                                            onClick={() => setSelectedEvent(event)}
                                        >
                                            <h5>{event.title}</h5>
                                            <p className="event-club"><img src={event.clubImg} alt={event.club} className="club-img" />{event.club}</p>

                                            <div className="event-img-wraper">
                                                <img src={event.img} alt={event.title} className="event-img" />
                                                {/* Show Tags for Booked & Interested */}
                                                {isAuthenticated && (
                                                    <div className="event-tags">
                                                        {event.isBooked && <span className="tag booked">Booked</span>}
                                                        {event.isInterested && <span className="tag interested">Interested</span>}
                                                    </div>
                                                )}
                                            </div>
                                            <p className="event-date">
                                                <FaCalendarCheck />
                                                {selectedEvent?.date
                                                    ? `${new Date(selectedEvent.date).toLocaleDateString("en-US", {
                                                        month: "short",
                                                        day: "2-digit",
                                                        year: "numeric",
                                                    })} | ${new Date(selectedEvent.date).toLocaleTimeString("en-US", {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true,
                                                    })}`
                                                    : "Date not available"}
                                            </p>
                                        </ListGroup.Item>
                                    ))}
                                </ListGroup>
                            ) : (
                                <p className="text-center text-muted mt-3">No past events</p>
                            )}
                        </Tab>
                    </Tabs>
                </Col>


                {/* Event Details */}
                <Col md={7} lg={8} className="event-details">
                    {selectedEvent ? (
                        <div className="post">
                            <div className="post-header">
                                <div className="profile-image">
                                    <img src={selectedEvent.clubImg} alt="Profile" className="profile-pic" />
                                </div>
                                <div className="profile-text">
                                    <h4>{selectedEvent.club}</h4>
                                </div>

                            </div>
                            {/* Post Image */}
                            <div className="post-image">
                                <img src={selectedEvent.img} alt="Post" />
                            </div>

                            {/* Event Details (If it's an Event) */}
                            {selectedEvent.type === "event" && (
                                <div className="event-stack-details">
                                    <p className="event-date">
                                        <FaCalendarCheck />
                                        {selectedEvent?.date
                                            ? `${new Date(selectedEvent.date).toLocaleDateString("en-US", {
                                                month: "short",
                                                day: "2-digit",
                                                year: "numeric",
                                            })} | ${new Date(selectedEvent.date).toLocaleTimeString("en-US", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                            })}`
                                            : "Date not available"}
                                    </p>
                                    <p className="event-stack">
                                        <span><BsFillPeopleFill />{selectedEvent.going} <strong>Going:</strong>  </span>
                                        <span><FaStar />{selectedEvent.interested} <strong>Interested</strong></span>
                                    </p>
                                </div>
                            )}

                            {/* Caption Section */}
                            <div className="caption">
                                <h4>{selectedEvent.title}</h4>
                                <p>{selectedEvent.description}</p>
                            </div>

                            {/* Event Buttons (Only for event) */}
                            {isAuthenticated && selectedEvent.type === "event" && selectedEvent?.date && new Date(selectedEvent.date) >= new Date() && (
                            // {isAuthenticated && selectedEvent.type === "event" && (
                                <div className="event-actions">
                                    {/* Case 1: If both isBooked and isInterested are true, show both buttons */}
                                    {selectedEvent?.isBooked && selectedEvent?.isInterested ? (
                                        <>
                                            <Button
                                                disabled
                                                className="custom-booking-button booked"
                                            >
                                                <span className="price">$20.50</span>
                                                <span className="label">
                                                    <GrCheckmark /> Booked
                                                </span>
                                            </Button>

                                            <Button
                                                disabled={!isAuthenticated}
                                                variant="interest"
                                                onClick={handleInterestedToggle}
                                            >
                                                <FaStar /> Interested
                                            </Button>
                                        </>
                                    ) : selectedEvent?.isBooked ? (
                                        // Case 2: If only booked, show only "Booked" button (disabled)
                                        <Button
                                            disabled
                                            className="custom-booking-button booked"
                                        >
                                            <span className="price">$20.50</span>
                                            <span className="label">
                                                <GrCheckmark /> Booked
                                            </span>
                                        </Button>
                                    ) : selectedEvent?.isInterested ? (
                                        // Case 3: If only interested, show both "Book a Seat" and "Interested" button
                                        <>
                                            <Button
                                                disabled={!isAuthenticated || isBooked} // Disable if not authenticated OR already booked
                                                className={`custom-booking-button ${isBooked ? "booked" : ""}`}
                                                onClick={handleBooking}
                                            >
                                                <span className="price">$20.50</span>
                                                <span className="label">
                                                    {isBooked ? (
                                                        <>
                                                            <GrCheckmark /> Booked
                                                        </>
                                                    ) : (
                                                        "Book a Seat"
                                                    )}
                                                </span>
                                            </Button>

                                            <Button
                                                disabled={!isAuthenticated}
                                                variant="interest"
                                                onClick={handleInterestedToggle}
                                            >
                                                <FaStar /> Interested
                                            </Button>
                                        </>
                                    ) : (
                                        // Case 4: If neither booked nor interested, show both "Book a Seat" and "Show Interest" buttons
                                        <>
                                            <Button
                                                disabled={!isAuthenticated || isBooked} // Disable if not authenticated OR already booked
                                                className={`custom-booking-button ${isBooked ? "booked" : ""}`}
                                                onClick={handleBooking}
                                            >
                                                <span className="price">$20.50</span>
                                                <span className="label">
                                                    {isBooked ? (
                                                        <>
                                                            <GrCheckmark /> Booked
                                                        </>
                                                    ) : (
                                                        "Book a Seat"
                                                    )}
                                                </span>
                                            </Button>

                                            <Button
                                                disabled={!isAuthenticated}
                                                variant={isInterested ? "interest" : "interest"}
                                                onClick={handleInterestedToggle}
                                            >
                                                {isInterested ? <><FaStar /> Interested</> : "Show Interest"}
                                            </Button>
                                        </>
                                    )}
                                </div>
                            )}

                            {/* Actions Section */}
                            <div className="post-actions">
                                {/* Love Button */}
                                <div className="items">
                                    <Button
                                        disabled={!isAuthenticated} // Only enable if authenticated
                                        variant="link"
                                        className="p-0 no-underline action-button"
                                        onClick={() => setLoved(!loved)}
                                    >
                                        <IoHeartCircle className="icon" />
                                        <span>{loved ? parseInt(selectedEvent.likes) + 1 : selectedEvent.likes} <span className="item-text">Loves</span></span>
                                    </Button>
                                </div>

                                {/* Comment Button */}
                                <div className="items">
                                    <Button
                                        disabled={!isAuthenticated} // Only enable if authenticated
                                        variant="link"
                                        className="p-0 no-underline action-button"
                                        onClick={() => setCommentsOpen(!commentsOpen)}
                                    >
                                        <IoChatbox className="icon" />
                                        <span>{selectedEvent.comments} <span className="item-text">Comments</span></span>
                                    </Button>
                                </div>

                                {/* Share Button */}
                                <div className="items">
                                    <span><span className="item-text">{selectedEvent.shares} Times Shared</span></span>
                                    <Button
                                        disabled={!isAuthenticated} // Only enable if authenticated
                                        variant="outline-secondary"
                                        className="br-10 share-button"
                                    >
                                        <FaShare className="icon" />
                                        Share
                                    </Button>
                                </div>
                            </div>

                            {/* Comment Box - Controlled by commentsOpen */}
                            <div className={`comment-box ${commentsOpen ? "show" : "hide"}`}>
                                <input
                                    type="text"
                                    placeholder="Add your comment here"
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                />
                                <Button variant="secondary" className={`search-button ${searchText ? "active" : ""}`}>
                                    <IoPaperPlane />
                                </Button>
                            </div>

                        </div>
                    ) : (
                        <p className="text-center text-muted">No events to display</p>
                    )}
                </Col>
            </Row>
        </div>
    );
};

export default Events;
